export const GET_LOGIN_INFORMATION = '[LOGIN][INFORMATION] fetching information';
export const GET_LOGIN_INFORMATION_SUCCESS = '[LOGIN][INFORMATION] Info succeded';
export const GET_LOGIN_INFORMATION_FAILURE = "[LOGIN][INFORMATION] Info Failed :'(";
export const POST_LOGIN_PENDING = '[LOGIN][REQUEST] Try to Login';
export const POST_LOGIN_SUCCESS = '[LOGIN][REQUEST] Login Succesfull';
export const POST_LOGIN_FAILURE = '[LOGIN][REQUEST] Login Failed';
export const POST_FORGOT_PASSWORD_PENDING = '[FORGOT_PASSWORD][REQUEST] Try to ForgotPassword';
export const POST_FORGOT_PASSWORD_SUCCESS = '[FORGOT_PASSWORD][REQUEST] ForgotPassword Succesfull';
export const POST_FORGOT_PASSWORD_FAILURE = '[FORGOT_PASSWORD][REQUEST] ForgotPassword Failed';
export const CLEAR_ERRORS = '[LOGIN][REDUCER] Delete Errors';
export const CLEAR_LOGIN_ATTEMPTS = '[LOGIN][REDUCER] Clear login attempts';
export const RETURN_TO_LOGIN = '[LOGIN][REDUCER] Go back to login';
export const VALIDATE_CODE_PENDING = '[TWO_FACTOR_AUTH][REQUEST] Call Service for Validate code';
export const VALIDATE_CODE_SUCCESS = '[TWO_FACTOR_AUTH][REQUEST] Validate code Successful';
export const VALIDATE_CODE_FAILURE = '[TWO_FACTOR_AUTH][REQUEST] Validate code Failure';
export const GOTO_FORGOT_PASSWORD = '[REDIRECT] Go to Forgot Password';
export const GOTO_LOGIN = '[REDIRECT] Go to Login';
export const RESEND_CODE_PENDING = '[TWO_FACTOR_AUTH][RESEND_CODE] Send Code again';
export const RESEND_CODE_SUCCESS = '[TWO_FACTOR_AUTH][RESEND_CODE] success';
export const RESEND_CODE_FAILURE = '[TWO_FACTOR_AUTH][RESEND_CODE] failure';
export const RESET_PASSWORD_PENDING = '[RESET_PASSWORD][RESET] pending password reset';
export const RESET_PASSWORD_SUCCESS = '[RESET_PASSWORD][RESET] success password reset';
export const RESET_PASSWORD_FAILURE = '[RESET_PASSWORD][RESET] failure password reset';
export const UPDATE_USER_ROLES = '[LOGIN][UPDATE] update user roles';
export const USER_VALIDATE_TOKEN = '[USER][VALIDATE] user token validate pending';
export const USER_VALIDATE_SUCCESS = '[USER][VALIDATE] user validate success';
export const CLEAR_SESSION = '[LOGIN][RESET] clear session';
export const SET_USER_FROM_SESSION = '[LOGIN][SESSION] set user/token from session storage';
export const LOGOUT_SESSION = '[LOGOUT][SESSION] expire token';
/* TO BE REMOVED */
export const VALIDATE_USER_PENDING = '[LOGIN][VALIDATE] pending user validate';
export const VALIDATE_USER_SUCCESS = '[LOGIN][VALIDATE] succress user validate';
export const VALIDATE_USER_FAILURE = '[LOGIN][VALIDATE] falure user validate';
/* TO BE REMOVED */

const json = {
  GET_LOGIN_INFORMATION,
  GET_LOGIN_INFORMATION_FAILURE,
  GET_LOGIN_INFORMATION_SUCCESS,
  POST_FORGOT_PASSWORD_FAILURE,
  POST_FORGOT_PASSWORD_PENDING,
  VALIDATE_CODE_PENDING,
  VALIDATE_CODE_SUCCESS,
  VALIDATE_CODE_FAILURE,
  GOTO_FORGOT_PASSWORD,
  RESEND_CODE_PENDING,
  RESEND_CODE_SUCCESS,
  RESEND_CODE_FAILURE,
  VALIDATE_USER_PENDING,
  VALIDATE_USER_SUCCESS,
  VALIDATE_USER_FAILURE,
};

export default json;
